export const getUserFromLocalStorage = () => {
  return localStorage.getItem("userDetails")
    ? JSON.parse(localStorage.getItem("userDetails"))
    : null;
};

export const getPostLoginPath = (user) =>
  user?.role === "store-team" ? "/sis-sales" : "/dashboard";
